export default "__VITE_ASSET__Bdv4iwtR__"